import { z } from 'zod'

const CurrencyOptionSchema = z.object({
	amount: z.number(),
	rate: z.number().optional(),
	lock: z.boolean().optional(),
	date: z.string().optional(),
})

const CurrencyOptionsSchema = z.record(z.string(), CurrencyOptionSchema)

export const ShippingRateSchema = z.object({
	id: z.string(),
	storeId: z.string(),
	accountId: z.string().nullable().optional(),
	shippingRateName: z.string(),
	description: z.string().nullable().optional(),
	icon: z.string().nullable().optional(),
	highlighted: z.boolean().default(false),
	amount: CurrencyOptionsSchema,
	shippingRateMinAmount: CurrencyOptionsSchema.nullable().optional(),
	shippingRateMaxAmount: CurrencyOptionsSchema.nullable().optional(),
	shippingRateMinWeight: z.number().nullable().optional(),
	shippingRateMaxWeight: z.number().nullable().optional(),
	countryCodes: z.array(z.string()).default([]),
	estimatedDeliveryTime: z.number().nullable().optional(),
	deletedAt: z.date().nullable().optional(),
	isFree: z.boolean().default(false),
	isPickupPoint: z.boolean().default(false),
	pickupPointCarriers: z.array(z.string()).default([]),
	createdAt: z.date().optional(),
	updatedAt: z.date().optional(),
})

export type ShippingRateType = z.infer<typeof ShippingRateSchema>

export const toShippingRateDto = (data: any): ShippingRateType => {
	return ShippingRateSchema.parse({
		...data,
		highlighted: data.highlighted ?? false,
		countryCodes: data.countryCodes ?? [],
		isFree: data.isFree ?? false,
		isPickupPoint: data.isPickupPoint ?? false,
		pickupPointCarriers: data.pickupPointCarriers ?? [],
	})
}

